import * as yup from "yup";

import { CommonErrors } from "application/constants/validations";

export const InvestSchema = (minAmount: number) =>
  yup.object({
    amount: yup.number().min(minAmount),
    investmentDoneAs: yup.string().required(),
    legalEntityId: yup.number().nullable(),
  });

export const confirmCommitmentSchema = yup.object({
  isConditionsAccepted: yup
    .boolean()
    .oneOf([true], CommonErrors.requiredField)
    .required(CommonErrors.requiredField),
  isInvestmentConfirmed: yup
    .boolean()
    .oneOf([true], CommonErrors.requiredField)
    .required(CommonErrors.requiredField),
});
